import { CloseButton } from "../components/CloseButton";

export const DemoProjects = () => {
  const projects = [
    {
      id: 1,
      name: "Stationstraat 40a, Mill",
      description: "Factsheet Mill",
      link: "/report/rapport1",
    },
    {
      id: 2,
      name: "Langstraat 221, Gendt",
      description: "Quickscan Gendt",
      link: "/report/rapport2",
    },
    { id: 3, name: "Volgend project", description: "Hier kun je zelf projecten maken" },
  ];

  return (
    <div className="fixed left-10 sm:left-20 mt-14 bg-sidebar-menu border-r border-r-sidebar-menu-border h-screen z-10 w-[calc(100vw-5rem)] sm:w-[28rem] max-w-[32rem] overflow-y-auto">
      <div className="p-6">
        <CloseButton className="text-black hover:text-gray hover:bg-black" />
        <h1 className="text-2xl font-semibold mb-4">Bewaarde locaties / projecten </h1>
        <ul className="space-y-4">
          {projects.map((project) => (
            <li key={project.id} className="p-4 border rounded shadow">
              <h2 className="text-lg font-bold">{project.name}</h2>
              <p>
                <a href={project.link || ""}>{project.description}</a>
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
